import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import TeamsForm from '../TeamsForm';

const TeamsModal = ({ visible, onClose, data, submitEditForm, error, title }) => {
  const [submit, setSubmit] = useState(false);
  const [reset, setReset] = useState(false);

  const formSubmit = (values) => {
    const _id = data ? data?.id : undefined;
    submitEditForm(_id, values);
    setSubmit(false);
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <TeamsForm
            submitOutside={submit}
            formProps={data || {}}
            error={error}
            reset={reset}
            resetConfirm={() => setReset(false)}
            submit={formSubmit}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="teams-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button key={2} data-testid="teams-modal-confirm-btn" onClick={() => setSubmit(true)}>
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TeamsModal;
